import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>zelfstandig</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onz</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            ali–
            <strong>quis</strong>
          </td>
          <td>
            ali–
            <strong>quid</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            ali–
            <strong>cuius</strong>
          </td>
          <td>
            ali–
            <strong>cuius</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            ali–
            <strong>cui</strong>
          </td>
          <td>
            ali–
            <strong>cui</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>
            ali–
            <strong>quem</strong>
          </td>
          <td>
            ali–
            <strong>quid</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            ali–
            <strong>quo</strong>
          </td>
          <td className="bor-bot">
            ali–
            <strong>quo</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            ali–
            <strong>qui</strong>
          </td>
          <td>
            ali–
            <strong>quae</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            ali–
            <strong>quorum</strong>
          </td>
          <td>
            ali–
            <strong>quorum</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            ali–
            <strong>quibus</strong>
          </td>
          <td>
            ali–
            <strong>quibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            ali–
            <strong>quos</strong>
          </td>
          <td>
            ali–
            <strong>quae</strong>
          </td>
        </tr>
        <tr>
          <th className="bor-bot col">abl. mv.</th>
          <td className="bor-bot">
            ali–<strong>quibus</strong>
          </td>
          <td className="bor-bot">
            ali–<strong>quibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td className="center">
            <i>iemand</i>
          </td>
          <td className="center">
            <i>iets</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje gaat hetzelfde als het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>quis/quid</b>
        </a>
        .
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>bijvoeglijk</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            ali–
            <strong>qui</strong>
          </td>
          <td>
            ali–
            <strong>qua</strong>
          </td>
          <td>
            ali–
            <strong>quod</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            ali–
            <strong>cuius</strong>
          </td>
          <td>
            ali–
            <strong>cuius</strong>
          </td>
          <td>
            ali–
            <strong>cuius</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            ali–
            <strong>cui</strong>
          </td>
          <td>
            ali–
            <strong>cui</strong>
          </td>
          <td>
            ali–
            <strong>cui</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            ali–
            <strong>quem</strong>
          </td>
          <td>
            ali–
            <strong>quam</strong>
          </td>
          <td>
            ali–
            <strong>quod</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            ali–
            <strong>quo</strong>
          </td>
          <td className="bor-bot">
            ali–
            <strong>qua</strong>
          </td>
          <td className="bor-bot">
            ali–
            <strong>quo</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            ali–
            <strong>qui</strong>
          </td>
          <td>
            ali–
            <strong>quae</strong>
          </td>
          <td>
            ali–
            <strong>quae</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            ali–
            <strong>quorum</strong>
          </td>
          <td>
            ali–
            <strong>quarum</strong>
          </td>
          <td>
            ali–
            <strong>quorum</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            ali–
            <strong>quibus</strong>
          </td>
          <td>
            ali–
            <strong>quibus</strong>
          </td>
          <td>
            ali–
            <strong>quibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            ali–
            <strong>quos</strong>
          </td>
          <td>
            ali–
            <strong>quas</strong>
          </td>
          <td>
            ali–
            <strong>quae</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">
            ali–
            <strong>quibus</strong>
          </td>
          <td className="bor-bot">
            ali–
            <strong>quibus</strong>
          </td>
          <td className="bor-bot">
            ali–
            <strong>quibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            ev <i>een of andere</i> &nbsp;&nbsp;&nbsp; mv <i>sommige</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje lijkt erg op het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>qui/quae/quod</b>
        </a>
        . Alleen de nominativus enkelvoud vrouwelijk wijkt af (<i>–qua</i> in
        plaats van <i>–quae</i>).
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>zelfstandig</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onz</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            <strong>quis</strong>–quam
          </td>
          <td>
            <strong>quic</strong>–quam
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            <strong>cuius</strong>–quam
          </td>
          <td>
            <strong>cuius</strong>–quam
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            <strong>cui</strong>–quam
          </td>
          <td>
            <strong>cui</strong>–quam
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>
            <strong>quem</strong>–quam
          </td>
          <td>
            <strong>quic</strong>–quam
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            <strong>quo</strong>–quam
          </td>
          <td className="bor-bot">
            <strong>quo</strong>–quam
          </td>
        </tr>

        <tr>
          <th className="col" />
          <td className="center">
            <i>iemand</i>
          </td>
          <td className="center">
            <i>iets</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje gaat hetzelfde als het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>quis/quid</b>
        </a>
        . Alleen de nominativus en accusativus enkelvoud onzijdig wijkt af (
        <i>quic–</i> in plaats van <i>quid–</i>).
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>bijvoeglijk</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            <strong>qui</strong>–dam
          </td>
          <td>
            <strong>quae</strong>–dam
          </td>
          <td>
            <strong>quod</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            <strong>cuius</strong>–dam
          </td>
          <td>
            <strong>cuius</strong>–dam
          </td>
          <td>
            <strong>cuius</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            <strong>cui</strong>–dam
          </td>
          <td>
            <strong>cui</strong>–dam
          </td>
          <td>
            <strong>cui</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            <strong>quen</strong>–dam
          </td>
          <td>
            <strong>quan</strong>–dam
          </td>
          <td>
            <strong>quod</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            <strong>quo</strong>–dam
          </td>
          <td className="bor-bot">
            <strong>qua</strong>–dam
          </td>
          <td className="bor-bot">
            <strong>quo</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            <strong>qui</strong>–dam
          </td>
          <td>
            <strong>quae</strong>–dam
          </td>
          <td>
            <strong>quae</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            <strong>quorun</strong>–dam
          </td>
          <td>
            <strong>quarun</strong>–dam
          </td>
          <td>
            <strong>quorun</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            <strong>quibus</strong>–dam
          </td>
          <td>
            <strong>quibus</strong>–dam
          </td>
          <td>
            <strong>quibus</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            <strong>quos</strong>–dam
          </td>
          <td>
            <strong>quas</strong>–dam
          </td>
          <td>
            <strong>quae</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">
            <strong>quibus</strong>–dam
          </td>
          <td className="bor-bot">
            <strong>quibus</strong>–dam
          </td>
          <td className="bor-bot">
            <strong>quibus</strong>–dam
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            ev <i>een of andere</i> &nbsp;&nbsp;&nbsp; mv <i>sommige</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje lijkt erg op het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>qui/quae/quod</b>
        </a>
        , met één verschil: vormen die op <b>-m</b> eindigen, krijgen een{" "}
        <b>-n</b> (dus: <i>quam</i> → <i>quandam</i>).
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>zelfstandig</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onz</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            <strong>quis</strong>–que
          </td>
          <td>
            <strong>quid</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            <strong>cuius</strong>–que
          </td>
          <td>
            <strong>cuius</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            <strong>cui</strong>–que
          </td>
          <td>
            <strong>cui</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>
            <strong>quem</strong>–que
          </td>
          <td>
            <strong>quid</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            <strong>quo</strong>–que
          </td>
          <td className="bor-bot">
            <strong>quo</strong>–que
          </td>
        </tr>

        <tr>
          <th className="col" />
          <td className="center">
            <i>iedereen</i>
          </td>
          <td className="center">
            <i>alles</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje gaat hetzelfde als het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>quis/quid</b>
        </a>
        .
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>bijvoeglijk</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            <strong>quis</strong>–que
          </td>
          <td>
            <strong>quae</strong>–que
          </td>
          <td>
            <strong>quod</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            <strong>cuius</strong>–que
          </td>
          <td>
            <strong>cuius</strong>–que
          </td>
          <td>
            <strong>cuius</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            <strong>cui</strong>–que
          </td>
          <td>
            <strong>cui</strong>–que
          </td>
          <td>
            <strong>cui</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            <strong>quem</strong>–que
          </td>
          <td>
            <strong>quam</strong>–que
          </td>
          <td>
            <strong>quod</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            <strong>quo</strong>–que
          </td>
          <td className="bor-bot">
            <strong>qua</strong>–que
          </td>
          <td className="bor-bot">
            <strong>quo</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            <strong>qui</strong>–que
          </td>
          <td>
            <strong>quae</strong>–que
          </td>
          <td>
            <strong>quae</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            <strong>quorum</strong>–que
          </td>
          <td>
            <strong>quarum</strong>–que
          </td>
          <td>
            <strong>quorum</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            <strong>quibus</strong>–que
          </td>
          <td>
            <strong>quibus</strong>–que
          </td>
          <td>
            <strong>quibus</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            <strong>quos</strong>–que
          </td>
          <td>
            <strong>quas</strong>–que
          </td>
          <td>
            <strong>quae</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">
            <strong>quibus</strong>–que
          </td>
          <td className="bor-bot">
            <strong>quibus</strong>–que
          </td>
          <td className="bor-bot">
            <strong>quibus</strong>–que
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>iedere, elke</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje lijkt erg op het rijtje van{" "}
        <a href="vragend-voornaamwoord">
          <b>qui/quae/quod</b>
        </a>
        . Alleen de nominativus enkelvoud mannelijk wijkt af (<i>quis–</i> in
        plaats van <i>qui–</i>).
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/onbep-vnw.js